import React from 'react';
import { useIntl } from 'react-intl-next';
import { DatePicker } from '@atlaskit/datetime-picker';
import { DEFAULT_LOCALE } from '../../../../intl-provider/ProFormaIntlProvider';
import { DisplayMode } from '../../RenderForm';
import { longDateOnlyFormat } from '../common/defaultDateTimeFormats';
import { FieldDisabledWrapper, ShortFieldWrapper, ViewWrapper } from '../common/questionWrappers';
const formatValueForView = (currentAnswer, locale) => {
  if (!currentAnswer || currentAnswer.length === 0) {
    return '';
  }
  return new Intl.DateTimeFormat(locale, {
    ...longDateOnlyFormat,
    timeZone: 'UTC'
  }).format(Date.parse(currentAnswer));
};
export const ViewDate = ({
  id,
  value,
  displayMode
}) => {
  const intl = useIntl();
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    return /*#__PURE__*/React.createElement(ShortFieldWrapper, null, /*#__PURE__*/React.createElement(FieldDisabledWrapper, null, /*#__PURE__*/React.createElement(DatePicker, {
      id: id,
      value: value,
      locale: intl.locale || DEFAULT_LOCALE,
      placeholder: " ",
      isDisabled: true,
      appearance: "subtle",
      shouldShowCalendarButton: true
    })));
  }
  return /*#__PURE__*/React.createElement(ViewWrapper, null, formatValueForView(value, intl.locale));
};